import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isMobile", "isDesktop"];
import { createContext, useContext } from 'react';
import { useWidthMediaQueries } from './useWidthMediaQueries';
import { ScreenSize } from './MediaQuery';
import { DesktopAppDims } from '../styling-utils/DesktopAppDims';
import { MobileAppDims } from '../styling-utils/MobileAppDims';
import { jsx as _jsx } from "react/jsx-runtime";
export const ResponsivenessContext = /*#__PURE__*/createContext({
  isDesktop: false,
  isMobile: false,
  isPortraitTablet: false,
  widthBreakpoint: 0,
  shouldResizeOAuthButton: false
});
const ResponsivenessProvider = ({
  children
}) => {
  const widthBreakpoint = useWidthMediaQueries();

  // For now, Mobile includes Tablet
  const isDesktop = widthBreakpoint >= ScreenSize.Desktop;
  const isMobile = widthBreakpoint <= ScreenSize.MD;
  const isPortraitTablet = ScreenSize.SM < widthBreakpoint && widthBreakpoint <= ScreenSize.MD;
  const shouldResizeOAuthButton = widthBreakpoint < ScreenSize.SM;
  return /*#__PURE__*/_jsx(ResponsivenessContext.Provider, {
    value: {
      widthBreakpoint,
      isDesktop,
      isMobile,
      isPortraitTablet,
      shouldResizeOAuthButton
    },
    children: children
  });
};
export default ResponsivenessProvider;
export const useResponsiveness = () => {
  const _useContext = useContext(ResponsivenessContext),
    {
      isMobile,
      isDesktop
    } = _useContext,
    attibutes = _objectWithoutPropertiesLoose(_useContext, _excluded);
  const APP_DIMS = isMobile ? MobileAppDims : DesktopAppDims;
  return Object.assign({}, attibutes, {
    isMobile,
    isDesktop,
    APP_DIMS
  });
};